import { render, staticRenderFns } from "./searchCommunityDataList.vue?vue&type=template&id=1966145b&scoped=true"
import script from "./searchCommunityDataList.vue?vue&type=script&lang=js"
export * from "./searchCommunityDataList.vue?vue&type=script&lang=js"
import style0 from "./searchCommunityDataList.vue?vue&type=style&index=0&id=1966145b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1966145b",
  null
  
)

export default component.exports